// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper___KTXk","col":"styles_col__1-AO3"};